<template>
  <div :class="['add-seller-account', cssClass]">
    <amazon-region-connect
      :show-nickname="showNickname"
      :show-pricing-message="!$root.hasDailyPricing"
      :redirect-path="$route.path"
      @error="onConnectError"
    />
  </div>
</template>

<script>
import AmazonRegionConnect from '../AmazonRegionConnect.vue'

export default {
  components: {
    AmazonRegionConnect
  },
  props: {
    showNickname: {
      default: true,
      type: Boolean
    },
    cssClass: {
      default: '',
      type: String
    }
  },
  methods: {
    onConnectError: function (message) {
      this.$emit('error', message)
    }
  }
}
</script>

<style scoped>
.add-seller-account {
  max-width: 100%;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// AddSellerAccount.vue?2f79fa6e